export class VeritiyPricesTableRowModel {
    constructor(
        public position: number,
        public width: number,
        public name: string,
        public key: string,
        public visible: boolean,
        public textAlign: string,
        public dynamicWidth?: boolean) {
    }

    isVisible(): boolean {
        return this.visible;
    }
}
